import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import { getAppraiserSignatureExists, addAppraiserSignature, deleteAppraiserSignature } from "requests/appraiser";
import FilePreview from "containers/Homeowner/MCaseView/FileManager/FilePreview";
import { MDropzone, MCard } from "components/Shared";
import WebConfig from "middlewares/WebConfig";
import { connect } from "react-redux";
import { APPRAISER_SIGNATURE_VIEW, APPRAISER_SIGNATURE_EDIT } from "typeConstants/rights";

const AppraiserSignature = props => {

  //User Rights
  const viewRight = props.rights.includes(APPRAISER_SIGNATURE_VIEW);
  const editRights = props.rights.includes(APPRAISER_SIGNATURE_EDIT);
 
  // manage signature file and preview state 
  const [signatureFile, setSignatureFile] = useState([]);
  const [previewFile, setPreviewFile] = useState(null);

  // used in the webapi calls if he user closes or switches screens mid call
  let mounted = useRef(true);

  //connect the user rights to the buttons in the dropzone
  const dropzoneRightsOverrides = {
    download: viewRight,
    preview: viewRight,
    delete: editRights,
  };

  //The Appraiser list will preventDefault and cause issues when trying to upload a file so we need to stop propagation
  const mouseEventHandler = (x) => {
    x.stopPropagation();
  };

  // add mouseEventHandler on load and remove it in the clean up function 
  useEffect(
    () => {
      if (editRights) {
        document.addEventListener("dragover", mouseEventHandler);
      }

      return () => {
        mounted.current = false;
        document.removeEventListener("dragover", mouseEventHandler);
      };
    }, []
  );

  // when receive a new appariser number load the signature file
  useEffect(() => {
    reload();
  }, [props.appraiserNumber]);

  // file load - checks if SignatureImagePath exists on the appraiser 
  const reload = () => {
    // getAppraiserSignatureExists success save callback
    const successSave = (data) => {
      if (data === false) return;
      displaySignatureFile();
    };

    if (!props.appraiserNumber) return [];
    getAppraiserSignatureExists(props.appraiserNumber, successSave, mounted);
  };


  // since there can only be 1 signature we are just going to display or hide the static file name
  const displaySignatureFile = () => {
    const { webApiRoot } = WebConfig;

    setSignatureFile([{
      "canDelete": true,
      "downloadUrl": `${webApiRoot}/appraiser/${props.appraiserNumber}/signature/download`,
      "fileName": "Signature file.png",
      "viewUrl": `${webApiRoot}/appraiser/${props.appraiserNumber}/signature/view`
    }]);
  };

  //hide signature file
  const hideSignatureFile = () => {
    setSignatureFile([]);
  };

  // upload attachment
  const addAttachments = (files) => {

    // success callback for addAppraiserSignature - display the signature
    const successSave = () => {
      displaySignatureFile();
    };

    // edit rights are needed to add a file
    if (!editRights) return;

    // object that will be posted to the api on upload
    let data = {
      appraiserNumber: props.appraiserNumber,
      signatureImage: ""
    };

    // dropzone allows for multiple files to upload -- just pull the first 
    const filteredFiles = files.filter(({ file }) => file);
    if (filteredFiles.length > 0 && data.appraiserNumber) {

      let reader = new FileReader();
      reader.readAsDataURL(filteredFiles[0].file);

      reader.onloadend = function (evt) {

        if (evt.target.readyState == FileReader.DONE) {
          let convertedfile = evt.target.result;
          let cleanfile = convertedfile.substring(convertedfile.lastIndexOf(",") + 1);
          data.signatureImage = cleanfile;
          addAppraiserSignature(data, successSave, mounted);
        }

        reader.onerror = function () {
          window.console.log("Error: Unable to load image");
        };
      };
    }
  };

  const deleteAttachments = () => {
    const successDelete = () => {
      hideSignatureFile();
    };

    const errorDelete = () => {
      reload();
    };
    deleteAppraiserSignature(props.appraiserNumber, successDelete, errorDelete, mounted);
  };

  const openFilePreview = (file, urlWithSSO) => {
    let tab = window.open(urlWithSSO, "_blank");
    tab.focus();
  };

  let cardActions = previewFile ? [{ icon: "close", helpText: "Close Preview", onClick: () => setPreviewFile(null) }] : [];

  return (viewRight &&
    <MCard
      title="Appraiser Signature Manager"
      className=" manual-order-dropzone file-manager"
      actions={cardActions}>      
      {
        previewFile ?
          <FilePreview
            displayname={previewFile.name}
            path={previewFile.url}
          /> :

          <MDropzone
            existingFiles={signatureFile}
            multiple
            noClick
            onPreview={(file, urlWithSSO) => openFilePreview ? openFilePreview(file, urlWithSSO) : setPreviewFile({ name: file.name, url: urlWithSSO })}
            onFileAdd={(file) => addAttachments(file)}
            onFileRemove={() => deleteAttachments()}
            prompt={editRights ? "Drop Appraiser Signature File here" : "No Signature File attached - View only rights"}
            fileRightOverrides={dropzoneRightsOverrides}
            columnDefinitionOverride={[
              { name: "Name", dataSource: "name", className: "file-name-cell" },
              { name: "Type", dataSource: "extension", style: { width: "50px" } },
              { name: "Actions", dataSource: "actions", style: { width: "160px" } },
            ]}
          />
      }
    </MCard>

  );

};
AppraiserSignature.propTypes = {
  appraiserNumber: PropTypes.number,
  roles: PropTypes.array,
  rights: PropTypes.array,
};

const mapStateToProps = state => {
  return {
    roles: state.user.profile.roles,
    rights: state.user.profile.rights,
  };
};

export default connect(mapStateToProps)(AppraiserSignature);





